export default "__VITE_ASSET__CZgbu5uW__"